app.farmnetControllers.addCustomCode('personCoreController', function(
  $scope,
  controller,
  $injector
) {
  $injector.invoke([
    '$dialog',
    '$timeout',
    'i18nFilter',
    '$filter',
    '$rootScope',
    function($dialog, $timeout, i18nFilter, $filter, $rootScope) {
    }
  ]);

  /**
   * Overwrites the function 'propertyChanged' of the coreCommonController if called from the personCoreController.
   * Sets an array 'dirtyField' into the current person and adds the name of the field that was changed in FrontEnd.
   */
  ang.overrideFunction(controller, 'propertyChanged', function(
    baseFn,
    fieldName
  ) {
    var model = controller.details.person;
    if (model) {
      if (!model.dirtyFlags) {
        model.dirtyFlags = [];
      }
      model.dirtyFlags.push(fieldName);
    }
    return baseFn(fieldName);
  });

  /**
   * Sets the field 'dirtyFlags' to <null> if existent.
   * The dirtyFlags field can be set to the request object in order to give the backend information about changed form fields
   * in the FrontEnd. See also:
   * 'personCoreCustom.ang.overrideFunction(controller, "propertyChanged", function(baseFn, fieldName))'
   */
  ang.overrideFunction(controller, 'resetDirtyFlags', function() {
    var model = controller.details.person;
    model.dirtyFlags = null;
  });

  /**
   * Overwrites the function 'handleSaveResponse' of the coreCommonController if called from the personCoreController.
   * Clears the 'dirtyField' array after it was sent to the BackEnd.
   */
  ang.overrideFunction(controller, 'handleSaveResponse', function(
    baseFn,
    data,
    sentModel
  ) {
    // broadcast `data.listObject.invalid` to make it available in the `$scope` from `personCoreController.js`
    $scope.$broadcast('updatePersonInvalid', data.listObject.invalid);

    controller.resetDirtyFlags();
    controller.markCurrentStateSaved(); // `coreCommonController.js:675`

    return baseFn(data, sentModel); // `coreCommonController.js:540`
  });
});
